import { Component, Input, OnInit } from '@angular/core';
import moment from 'moment-business-days';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { DaysAndHoursPipe } from 'src/app/shared/pipe/days-and-hours.pipe';

import { PortalSettingsService } from '../../../core/services/portal-settings.service';

@Component({
  selector: 'app-floating-modal',
  templateUrl: './floating-modal.component.html',
  styleUrls: ['./floating-modal.component.css']
})
export class FloatingModalComponent implements OnInit {
  @Input() leaveCode: any;
  @Input() stdWorkdayHours: number
  @Input() date: Date;
  @Input() Languages: any[];
  @Input() settings: { [key: string]: any };
  @Input() totalAccruedFromDateLastUsed: number;
  @Input() dateDiff: number;
  @Input() format: string;
  latestRequestDate: any
  portalSettings: any;
  displayDate: string;
  hrTimeOffMessage: any;
  year: number;
  daysAndHours: DaysAndHoursPipe
  accrualRate: any;
  disableProjected: boolean;

  constructor(private portalSettingsService: PortalSettingsService, private ngbActiveModal: NgbActiveModal) {
    this.portalSettings = portalSettingsService.getPortalSettings();
  }

  ngOnInit(): void {
    this.daysAndHours = new DaysAndHoursPipe();
    this.accrualRate = this.leaveCode.AccrualRate != null ? this.leaveCode.AccrualRate.toFixed(4) : this.leaveCode.AccrualRate;
    this.hrTimeOffMessage = this.portalSettings.HRMesasageForTimeOff.ConfigValue;
    this.disableProjected = this.portalSettings.VCDisableProjected.ConfigValue == "1";
    this.displayDate = moment(this.date).format(this.format);
    this.year = new Date().getFullYear();
  }

  cancelClicked() {
    this.ngbActiveModal.close('cancel');
  };
}
